import {FC} from 'react';

import {Box, DialogContent, DialogTitle, Stack, Typography, useMediaQuery} from '@mui/material';
import {t} from 'i18next';

import Button from 'components/button/Button';
import {config} from 'config/env';
import theme from 'config/theme';
import ReactNative from 'services/react-native';

import {StyledDialog, StyledBottomSheet} from './styles';

export interface IAddressChangedModal {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
}

export const LocationMismatchModal: FC<IAddressChangedModal> = ({open, onClose, onSave}) => {
  const isMobileView = useMediaQuery(theme.breakpoints.only('mobile'));

  const isMobileScreen = ReactNative.isReactNativeWebView() || isMobileView;
  const ModalContainer = isMobileScreen ? StyledBottomSheet : StyledDialog;

  return (
    <ModalContainer
      className="MakroFleetDeliveryModal"
      open={open}
      onClose={onClose}
      anchor="bottom"
      ModalProps={{style: {zIndex: 1300}}}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="center" alignItems="flex-end" paddingTop={2}>
          <Typography fontWeight={700} fontSize="1.2rem">
            {t('locationMismatch.title')}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Box display="flex" gap={2} width="fit-content" textAlign={'center'}>
            <Typography fontSize={14} fontWeight={400}>
              {t('locationMismatch.description')}
            </Typography>
          </Box>
          <Stack gap={2}>
            <Button fullWidth shape="rounded" variant="contained" disabled={false} onClick={onClose}>
              {t('locationMismatch.button.review')}
            </Button>
            {!config.DISABLE_FORCE_SAVE_ON_ADDRESS_MISMATCH && (
              <Button fullWidth shape="rounded" variant="outlined" disabled={false} onClick={onSave}>
                {t('locationMismatch.button.confirm')}
              </Button>
            )}
          </Stack>
        </Stack>
      </DialogContent>
    </ModalContainer>
  );
};

LocationMismatchModal.displayName = 'LocationMismatchModal';
